import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { html } from '@resn/gozer-core';
import './index.scss';

const template = ({ props, options }) => html`
    <button
        type="button"
        class="closeBtn header__closeBtn"
        data-ui="close-btn"
        ?open=${props.open}
        @click="${options.handlerClick}"
    >
        <i class="closeBtn__cross">
            <span class="line"><span></span></span>
            <span class="line"><span></span></span>
        </i>
    </button>
`;

@componentMixin(DomComponentMixin)
class CloseButton extends Component {
    options = {
        template,
    };

    props = {};

    async onSetup() {}

    onOpen() {
        const d = 0.6;
        this.el.style.setProperty('--delay-open', `${d}s`);
        this.el.style.setProperty('--delay-open-half', `${d / 2}s`);
    }
    offOpen() {
        const d = 0.6;
        this.el.style.setProperty('--delay-open', `${d}s`);
        this.el.style.setProperty('--delay-open-half', `${d / 2}s`);
    }
}

export default CloseButton;
